import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Attachment } from 'src/app/models/item.model';

@Component({
  selector: 'app-document-attachment',
  templateUrl: './document-attachment.component.html',
  styleUrls: ['./document-attachment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class DocumentAttachmentComponent {
  @Input() attachment: Attachment;
  @Output() openAttachment = new EventEmitter<string>();

  action(event): void {
    event.stopPropagation();
    this.openAttachment.emit(this.attachment.attachmentId);
  }

  barClass(): string {
    if (this.attachment.downloading) {
      return 'bar downloading';
    }
    if (this.attachment.downloaded) {
      return 'bar downloaded';
    }
    return 'bar';
  }

  downloadIconClass(): string {
    if (this.attachment.downloaded) {
      return 'icon downloaded-icon';
    }
    return 'icon download-icon';
  }

  get size(): string {
    if (this.attachment.size < 1024) {
      return this.attachment.size + 'b';
    }
    if (this.attachment.size < 1024 * 1024) {
      return Math.round(this.attachment.size / 1024) + 'Kb';
    }
    return Math.round(this.attachment.size / 1024 / 1204) + 'Mb';
  }
}
